// extracted by mini-css-extract-plugin
module.exports = {"cover":"ShotCover_cover__2DN3W"};